/* ==========================================================================
   NESTEVA · Configurator BUBBLE  ·  v2
   --------------------------------------------------------------------------
   Se montează pe un singur element din pagină:

     <div id="nv-cfg" data-mod="magnet"></div>
     <script src="{{ 'nesteva-configurator.js' | asset_url }}" defer></script>

   data-mod = "magnet"  → vinde literele/cifrele magnetice + accesorii
   data-mod = "perete"  → vinde literele/cifrele de perete, cu Dimensiune M/L

   Prețurile, culorile și variantele se citesc AUTOMAT din Shopify.
   Nu există niciun preț scris de mână în acest fișier.
   ========================================================================== */
(function () {
  "use strict";

  /* ---------------------------------------------------------------- config */

  var HANDLES = {
    magnet: {
      letters: "litera-magnetica-bubble-nume-3d",
      numbers: "cifra-magnetica-bubble-data-3d",
      acc:     "accesoriu-magnetic-bubble-3d",
      montaj:  "Magnet neodim"
    },
    perete: {
      letters: "litera-bubble-nume-3d",
      numbers: "cifra-bubble-3d",
      acc:     null,                 // încă nu există accesoriu de perete
      montaj:  "Perete / uși"
    }
  };

  var ASSET_BASE = "//nesteva.store/cdn/shop/files/";

  /* Ordinea în care sunt oferite culorile. Cele care nu există în produs
     sunt eliminate automat, deci lista poate fi mai lungă decât catalogul. */
  var COLOR_DEFS = [
    { name: "Roz pastel",    slug: "roz-pastel",    css: "#e7b1c3" },
    { name: "Galben pastel", slug: "galben-pastel", css: "#ecd790" },
    { name: "Verde pastel",  slug: "verde-pastel",  css: "#c2d4a2" },
    { name: "Duo turcoaz",   slug: "duo-turcoaz",   css: "linear-gradient(160deg,#bfe3cd,#7fb1ab)" },
    { name: "Roșu închis",   slug: "rosu-inchis",   css: "#a04437" },
    { name: "Alb",           slug: "alb",           css: "#fbf8f2" }
  ];

  var DIA_SLUG = { "Ă": "Abreve", "Â": "Acirc", "Î": "Icirc",
                   "Ș": "Scomma", "Ş": "Scomma", "Ț": "Tcomma", "Ţ": "Tcomma" };

  var ACCS = [
    { slug: "inima",  name: "Inimă" },
    { slug: "floare", name: "Floare" },
    { slug: "stea",   name: "Stea" },
    { slug: "papion", name: "Papion" },
    { slug: "masina", name: "Mașină" }
  ];

  /* Fundalul previzualizării.
     La magnet sunt culorile reale ale tablelor NESTEVA.
     La perete sunt nuanțe de perete — alb implicit, plus câteva uzuale,
     ca literele albe să se vadă pe un perete care nu e alb pur. */
  var BOARDS = {
    magnet: [
      ["#C9925E", "Caramel"], ["#E7C9C1", "Roz pudră"], ["#A4AF90", "Verde salvie"],
      ["#E2D4BD", "Bej"],     ["#BE7256", "Terracottă"], ["#BFBFBA", "Gri"]
    ],
    perete: [
      ["#FFFFFF", "Alb"],        ["#F4EFE7", "Alb cald"],   ["#E3E3DF", "Gri deschis"],
      ["#E6DCCB", "Bej nisip"],  ["#DCE3D6", "Verde salvie"], ["#EFDCD8", "Roz pudră"]
    ]
  };
  var BOARD_LABEL = { magnet: "Culoare tablă:", perete: "Culoarea peretelui:" };

  // Termenul afișat sub butonul de comandă. Un singur loc pentru toate cele patru pagini.
  // Trebuie să spună exact ce scrie în politica de livrare și în datele structurate.
  var LIVRARE = "📦 <b>Produs la comandă.</b> Îl printăm după ce comanzi: " +
                "2–3 zile lucrătoare de producție, plus 1–3 zile de transport.";

  var COPY = {
    magnet: {
      eyebrow: "Litere & cifre magnetice",
      h1: "Litere magnetice 3D personalizate — numele lor, pe tablă sau pe frigider",
      lead: "Printate 3D la comandă în România · magnet de neodim · diacritice Ă Â Î Ș Ț incluse. " +
            "Se prind pe tablă magnetică, pe frigider sau pe orice suprafață metalică.",
      boardNote: "Previzualizare pe tabla magnetică NESTEVA · fiecare piesă are magnet de neodim pe spate",
      reassure: ["🧲 Se prind și pe frigider", "🚚 Gratuit peste 250 lei",
                 "🇷🇴 Făcut în România", "↩️ Retur 14 zile"]
    },
    perete: {
      eyebrow: "Litere & cifre pentru perete",
      h1: "Litere 3D pentru perete și uși — numele copilului, fără găuri",
      lead: "Printate 3D la comandă în România · diacritice Ă Â Î Ș Ț incluse. " +
            "Se lipesc simplu cu bandă dublu adezivă sau buline adezive (nu sunt incluse), " +
            "direct pe perete, pe ușă sau pe mobilă.",
      boardNote: "Previzualizare · culoarea de fundal e doar orientativă, piesele se lipesc pe orice suprafață",
      reassure: ["🧱 Fără găuri în perete", "🚚 Gratuit peste 250 lei",
                 "🇷🇴 Făcut în România", "↩️ Retur 14 zile"]
    }
  };

  var METRICS = {
    ref_cap: 460,
    glyphs: {
      A:{w:437},B:{w:356},C:{w:352},D:{w:370},E:{w:277},F:{w:293},G:{w:373},
      H:{w:472},I:{w:209},J:{w:318},K:{w:397},L:{w:317},M:{w:529},N:{w:459},
      O:{w:383},P:{w:326},Q:{w:391},R:{w:357},S:{w:316},T:{w:305},U:{w:417},
      V:{w:403},W:{w:599},X:{w:398},Y:{w:378},Z:{w:291},
      "0":{w:364,t:"num"},"1":{w:225,t:"num"},"2":{w:307,t:"num"},"3":{w:303,t:"num"},
      "4":{w:370,t:"num"},"5":{w:317,t:"num"},"6":{w:350,t:"num"},"7":{w:307,t:"num"},
      "8":{w:338,t:"num"},"9":{w:339,t:"num"},
      Abreve:{w:333,capTop:109.8},Acirc:{w:338,capTop:104.6},Icirc:{w:166,capTop:93.4},
      Scomma:{w:219,capBottom:319.1},Tcomma:{w:212,capBottom:319.1}
    }
  };
  Object.keys(METRICS.glyphs).forEach(function (k) {
    var g = METRICS.glyphs[k];
    g.h = 460;
    if (g.capTop == null) g.capTop = 0;
    if (g.capBottom == null) g.capBottom = 460;
    if (!g.t) g.t = "letter";
  });

  /* ------------------------------------------------------------- utilitare */

  function slugify(s) {
    return String(s == null ? "" : s).trim().toLowerCase()
      .replace(/ș|ş/g, "s").replace(/ț|ţ/g, "t")
      .replace(/ă|â/g, "a").replace(/î/g, "i")
      .replace(/\s+/g, "-");
  }

  function glyphSlug(ch) {
    var up = String(ch).toUpperCase();
    if (DIA_SLUG[up]) return DIA_SLUG[up];
    if (/^[A-Z0-9]$/.test(up)) return up;
    return null;
  }

  function money(cents) {
    return (cents / 100).toLocaleString("ro-RO", { minimumFractionDigits: 2 }) + " lei";
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* Imaginile sunt .webp în Files; câteva vechi au rămas .png.
     Punem webp și, la eroare, cădem o singură dată pe png. */
  function imgSrc(slug, colorSlug) {
    return ASSET_BASE + slug + "-" + colorSlug + ".webp";
  }
  function attachFallback(img) {
    img.addEventListener("error", function () {
      if (img.dataset.fb) return;
      img.dataset.fb = "1";
      img.src = img.src.replace(/\.webp(\?.*)?$/, ".png");
    });
  }

  /* --------------------------------------------------------- catalog / date */

  function Catalog() {
    this.products = {};   // rol -> product json
    this.index = {};      // rol -> { cheie -> variant }
    this.colors = [];     // culorile disponibile efectiv
    this.sizes = [];      // valorile de Dimensiune, dacă există
    this.finishes = [];   // valorile de Finisaj
  }

  Catalog.prototype.optIndex = function (prod, rx) {
    var names = (prod.options || []).map(function (o) {
      return typeof o === "string" ? o : (o && o.name) || "";
    });
    for (var i = 0; i < names.length; i++) if (rx.test(names[i])) return i;
    return -1;
  };

  Catalog.prototype.optValues = function (prod, rx) {
    var i = this.optIndex(prod, rx);
    if (i < 0) return [];
    var o = prod.options[i];
    return (typeof o === "string" ? [] : o.values) || [];
  };

  /* Cheie de variantă: culoare | dimensiune | finisaj (ce lipsește devine "-") */
  Catalog.prototype.buildIndex = function (rol, prod) {
    var ci = this.optIndex(prod, /culoare/i),
        di = this.optIndex(prod, /dimensiune|m[ăa]rime/i),
        fi = this.optIndex(prod, /finisaj/i),
        ai = this.optIndex(prod, /accesoriu|form[ăa]/i);
    var map = {};
    (prod.variants || []).forEach(function (v) {
      var vals = v.options || [v.option1, v.option2, v.option3];
      var parts = [
        ai >= 0 ? slugify(vals[ai]) : "-",
        ci >= 0 ? slugify(vals[ci]) : "-",
        di >= 0 ? slugify(vals[di]) : "-",
        fi >= 0 ? slugify(vals[fi]) : "-"
      ];
      map[parts.join("|")] = v;
    });
    this.index[rol] = map;
  };

  Catalog.prototype.find = function (rol, opts) {
    var map = this.index[rol];
    if (!map) return null;
    var key = [
      opts.acc  ? slugify(opts.acc)  : "-",
      opts.color ? slugify(opts.color) : "-",
      opts.size ? slugify(opts.size) : "-",
      opts.finish ? slugify(opts.finish) : "-"
    ].join("|");
    return map[key] || null;
  };

  Catalog.prototype.load = function (cfg) {
    var self = this;
    var jobs = [];
    ["letters", "numbers", "acc"].forEach(function (rol) {
      var h = cfg[rol];
      if (!h) return;
      jobs.push(
        fetch("/products/" + h + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            self.products[rol] = p;
            self.buildIndex(rol, p);
          })
          .catch(function () { /* produsul lipsește — mergem mai departe */ })
      );
    });
    return Promise.all(jobs).then(function () {
      var L = self.products.letters;
      if (!L) throw new Error("Produsul de litere nu a putut fi încărcat");

      var names = self.optValues(L, /culoare/i);
      self.colors = COLOR_DEFS.filter(function (c) {
        return names.some(function (n) { return slugify(n) === c.slug; });
      });
      /* dacă produsul are o culoare pe care nu o cunoaștem, o adăugăm gri */
      names.forEach(function (n) {
        if (!self.colors.some(function (c) { return c.slug === slugify(n); })) {
          self.colors.push({ name: n, slug: slugify(n), css: "#d8d2c6" });
        }
      });

      self.sizes = self.optValues(L, /dimensiune|m[ăa]rime/i);
      self.finishes = self.optValues(L, /finisaj/i);
      return self;
    });
  };

  /* ------------------------------------------------------------------ stil */

  var CSS = [
    '#nv-cfg{--sage:#5e6350;--sage-d:#4a4f3f;--cream:#f7f3ec;--cream-2:#efe9df;',
    '--ink:#3a3a32;--muted:#807c6f;--line:#e3ddd0;--white:#fffdf9;--radius:18px;',
    '--shadow:0 10px 30px rgba(70,70,55,.10);font-family:Nunito,system-ui,sans-serif;',
    'color:var(--ink);line-height:1.55}',
    '#nv-cfg *{box-sizing:border-box}#nv-cfg img{display:block}',
    '#nv-cfg h1,#nv-cfg h2,#nv-cfg h3{font-family:Quicksand,sans-serif;margin:0}',
    '#nv-cfg .wrap{max-width:1180px;margin:0 auto;padding:0 20px}',
    '#nv-cfg .cfg{display:grid;grid-template-columns:1.15fr .85fr;gap:30px;align-items:start;padding:8px 0 40px}',
    '#nv-cfg .board-card{position:sticky;top:84px}',
    '#nv-cfg .board{--board:#C9925E;position:relative;border-radius:18px;min-height:440px;width:100%;',
    'background:var(--board);box-shadow:0 14px 34px rgba(60,48,32,.16),inset 0 0 0 1px rgba(255,255,255,.10);',
    'display:flex;align-items:center;justify-content:center;overflow:hidden;transition:background-color .25s}',
    '#nv-cfg .board.wall{box-shadow:0 8px 22px rgba(60,55,40,.10), inset 0 0 0 1px rgba(80,75,60,.10);border-radius:12px}',
    '#nv-cfg .stage{display:inline-flex;align-items:flex-end;justify-content:center;flex-wrap:wrap;',
    'padding:30px 24px;position:relative;z-index:2;max-width:100%}',
    '#nv-cfg .glyph{position:relative;display:inline-block}',
    '#nv-cfg .glyph img{position:absolute;left:0;filter:drop-shadow(0 7px 8px rgba(40,30,15,.28));user-select:none}',
    '#nv-cfg .placeholder{color:rgba(255,255,255,.92);font-family:Quicksand;font-weight:600;',
    'font-size:20px;text-align:center;z-index:2;text-shadow:0 1px 4px rgba(0,0,0,.25)}',
    '#nv-cfg .bcolors{display:flex;gap:9px;justify-content:center;align-items:center;margin-top:14px;flex-wrap:wrap}',
    '#nv-cfg .bcolors b{font-size:13px;color:var(--muted);font-weight:700}',
    '#nv-cfg .bsw{width:30px;height:30px;border-radius:9px;cursor:pointer;border:2px solid #fff;',
    'box-shadow:0 0 0 1.5px var(--line);transition:transform .12s}',
    '#nv-cfg .bsw:hover{transform:scale(1.12)}#nv-cfg .bsw.sel{box-shadow:0 0 0 2px var(--sage)}',
    '#nv-cfg .board-note{text-align:center;color:var(--muted);font-size:12.5px;margin-top:12px}',
    '#nv-cfg .panel{background:var(--white);border:1px solid var(--line);border-radius:var(--radius);',
    'padding:22px;box-shadow:var(--shadow);margin-bottom:18px}',
    '#nv-cfg .eyebrow{font-size:12px;letter-spacing:2px;text-transform:uppercase;color:var(--sage);font-weight:700}',
    '#nv-cfg h1{font-size:25px;line-height:1.25;margin:6px 0 6px}',
    '#nv-cfg .subtle{color:var(--muted);font-size:14px;margin:0}',
    '#nv-cfg .step-t{font-family:Quicksand;font-weight:700;font-size:15px;display:flex;',
    'align-items:center;gap:9px;margin:0 0 12px}',
    '#nv-cfg .step-n{background:var(--sage);color:#fff;width:24px;height:24px;border-radius:50%;',
    'display:grid;place-items:center;font-size:13px}',
    '#nv-cfg .name-input{width:100%;font-family:Quicksand;font-weight:700;font-size:22px;letter-spacing:3px;',
    'text-transform:uppercase;padding:13px 16px;border:2px solid var(--line);border-radius:12px;',
    'background:var(--cream);color:var(--ink);outline:none}',
    '#nv-cfg .name-input:focus{border-color:var(--sage)}',
    '#nv-cfg .hint{font-size:12.5px;color:var(--muted);margin:8px 2px 0}',
    '#nv-cfg .master{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:6px}',
    '#nv-cfg .master span{font-size:13px;color:var(--muted);font-weight:600}',
    '#nv-cfg .swatch{width:30px;height:30px;border-radius:50%;border:2px solid #fff;',
    'box-shadow:0 0 0 1.5px var(--line);cursor:pointer;transition:transform .12s}',
    '#nv-cfg .swatch:hover{transform:scale(1.12)}',
    '#nv-cfg .letters{display:flex;flex-wrap:wrap;gap:10px;margin-top:4px}',
    '#nv-cfg .lchip{border:1.5px solid var(--line);border-radius:14px;padding:8px;width:74px;',
    'text-align:center;background:var(--cream)}',
    '#nv-cfg .lchip .pv{height:56px;position:relative;margin-bottom:6px}',
    '#nv-cfg .lchip .pv img{position:absolute;left:50%;transform:translateX(-50%);',
    'filter:drop-shadow(0 3px 3px rgba(60,55,40,.2))}',
    '#nv-cfg .lchip .dots{display:flex;gap:5px;justify-content:center;flex-wrap:wrap}',
    '#nv-cfg .dot{width:15px;height:15px;border-radius:50%;cursor:pointer;border:1.5px solid #fff;',
    'box-shadow:0 0 0 1px var(--line)}',
    '#nv-cfg .dot.sel{box-shadow:0 0 0 2px var(--sage)}',
    '#nv-cfg .seg{display:flex;background:var(--cream-2);border-radius:30px;padding:4px;gap:4px}',
    '#nv-cfg .seg button{flex:1;border:none;background:transparent;padding:10px;border-radius:26px;',
    'font-weight:700;font-family:Quicksand;cursor:pointer;font-size:13.5px;color:var(--muted)}',
    '#nv-cfg .seg button.on{background:var(--sage);color:#fff}',
    '#nv-cfg .pricebox{background:var(--cream);border:1px dashed var(--line);border-radius:14px;padding:16px}',
    '#nv-cfg .prow{display:flex;justify-content:space-between;font-size:14px;margin:5px 0;color:var(--muted)}',
    '#nv-cfg .ptotal{display:flex;justify-content:space-between;align-items:baseline;',
    'border-top:1px solid var(--line);margin-top:10px;padding-top:10px}',
    '#nv-cfg .ptotal b{font-family:Quicksand;font-size:30px;color:var(--ink)}',
    '#nv-cfg .btn{display:block;width:100%;text-align:center;background:var(--sage);color:#fff;border:none;',
    'font-family:Quicksand;font-weight:700;font-size:17px;padding:15px;border-radius:14px;cursor:pointer;',
    'margin-top:14px;transition:background .15s}',
    '#nv-cfg .btn:hover{background:var(--sage-d)}#nv-cfg .btn[disabled]{opacity:.5;cursor:not-allowed}',
    '#nv-cfg .reassure{display:flex;gap:14px;flex-wrap:wrap;justify-content:center;margin-top:12px;',
    'font-size:12.5px;color:var(--muted)}',
    '#nv-cfg .delivery{margin:12px 0 0;padding:10px 12px;background:var(--cream2);border-radius:12px;',
    'font-size:13px;color:var(--ink);text-align:center;line-height:1.5}',
    '#nv-cfg .delivery b{font-family:Quicksand;font-weight:700}',
    '#nv-cfg .acc-sec{background:var(--white);border:1px solid var(--line);border-radius:var(--radius);',
    'padding:26px;box-shadow:var(--shadow);margin-bottom:40px}',
    '#nv-cfg .acc-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;margin-top:16px}',
    '#nv-cfg .acard{border:2px solid var(--line);border-radius:16px;padding:14px;text-align:center;',
    'background:var(--cream);position:relative;transition:border-color .15s,transform .12s}',
    '#nv-cfg .acard.sel{border-color:var(--sage);background:#fff}',
    '#nv-cfg .acard img{height:74px;margin:0 auto 8px;filter:drop-shadow(0 5px 5px rgba(60,55,40,.18))}',
    '#nv-cfg .acard .nm{font-family:Quicksand;font-weight:600;font-size:14px}',
    '#nv-cfg .acard .qty{display:flex;align-items:center;justify-content:center;gap:12px;margin-top:10px}',
    '#nv-cfg .acard .qb{width:28px;height:28px;border-radius:8px;border:1.5px solid var(--line);',
    'background:#fff;font-size:17px;font-weight:700;cursor:pointer;color:var(--sage);display:grid;',
    'place-items:center;line-height:1}',
    '#nv-cfg .acard .qb:disabled{opacity:.35;cursor:not-allowed}',
    '#nv-cfg .acard .qn{font-family:Quicksand;font-weight:700;min-width:16px;font-size:16px}',
    '#nv-cfg .acc-foot{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;',
    'gap:10px;margin-top:18px}',
    '#nv-cfg .tag{display:inline-block;background:#eef0e6;color:var(--sage);font-weight:700;font-size:12px;',
    'border-radius:20px;padding:4px 12px}',
    '#nv-cfg-toast{position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(140px);',
    'background:#4a4f3f;color:#fff;padding:14px 22px;border-radius:30px;font-weight:700;',
    'font-family:Quicksand;box-shadow:0 10px 30px rgba(70,70,55,.2);transition:transform .3s;z-index:60}',
    '#nv-cfg-toast.show{transform:translateX(-50%) translateY(0)}',
    '@media(max-width:920px){#nv-cfg .cfg{display:flex;flex-direction:column;gap:0}',
    '#nv-cfg .cfg>div:last-child{display:contents}#nv-cfg .cfg>div:last-child .panel{order:3}',
    '#nv-cfg .nvp-intro{order:1!important}#nv-cfg .board-card{order:2;position:static;margin-bottom:18px}}',
    '@media(max-width:760px){#nv-cfg .acc-grid{grid-template-columns:repeat(2,1fr)}}',
    '@media(max-width:680px){#nv-cfg .board{min-height:300px}',
    '#nv-cfg .dot{width:24px;height:24px}#nv-cfg .dot.sel{box-shadow:0 0 0 2.5px var(--sage)}',
    '#nv-cfg .lchip{width:auto;min-width:142px;flex:1 1 142px}#nv-cfg .lchip .pv{height:64px}',
    '#nv-cfg .lchip .dots{gap:8px}#nv-cfg .swatch{width:34px;height:34px}}'
  ].join("");

  /* ------------------------------------------------------------------- app */

  function Configurator(root, mode, cat) {
    this.root = root;
    this.mode = mode;
    this.cfg = HANDLES[mode];
    this.cat = cat;
    this.copy = COPY[mode];

    this.cycle = cat.colors.slice(0, 4).map(function (c) { return c.slug; });
    if (!this.cycle.length) this.cycle = [cat.colors[0].slug];

    this.state = [];
    this.finish = (cat.finishes[0] || "Mat");
    this.size = (cat.sizes[0] || null);
    this.boards = BOARDS[mode] || BOARDS.magnet;
    this.board = this.boards[0][0];
    this.accCounts = {};
    this.accColor = {};
    var self = this;
    ACCS.forEach(function (a) {
      self.accCounts[a.slug] = {};
      self.accColor[a.slug] = self.cat.colors[0].slug;
    });

    // Numele poate veni din link: /products/...?nume=AVA
    // Așa, cine scrie un nume în promoul de pe prima pagină îl regăsește aici.
    var fromUrl = "";
    try {
      var qs = window.location.search || "";
      var mm = qs.match(/[?&]nume=([^&]*)/);
      if (mm) fromUrl = decodeURIComponent(mm[1].replace(/\+/g, " ")).slice(0, 24);
    } catch (e) { fromUrl = ""; }

    this.opts = {
      start: fromUrl || root.dataset.start || "MAIA",
      label: root.dataset.label || "Scrie numele sau cuvântul",
      hint:  root.dataset.hint  ||
             "Litere A–Z, diacritice (ă â î ș ț) și cifre 0–9. Spațiul desparte cuvintele."
    };
    this.build();
    this.setName(this.opts.start);
  }

  Configurator.prototype.build = function () {
    var self = this, c = this.copy, cat = this.cat;

    /* Dacă în pagină există deja un bloc de introducere scris în HTML
       (recomandat, ca Google să vadă titlul fără să ruleze JavaScript),
       îl păstrăm pe acela în loc să generăm unul nou. */
    var staticIntro = this.staticIntro || null;

    if (!document.getElementById("nv-cfg-style")) {
      var st = el("style"); st.id = "nv-cfg-style"; st.textContent = CSS;
      document.head.appendChild(st);
    }

    var hasAcc = !!(this.cfg.acc && cat.products.acc);
    var hasSize = cat.sizes.length > 1;
    var hasFinish = cat.finishes.length > 1;

    /* numerotarea pașilor, în ordinea în care apar pe pagină */
    var sNume = 1, sCol = 2, k = 3;
    var sSize = hasSize ? k++ : null;
    var sFin = hasFinish ? k++ : null;
    var sPrice = k;

    var sizeHtml = hasSize ? [
      '<div class="panel"><p class="step-t"><span class="step-n">', sSize,
      '</span> Alege dimensiunea</p><div class="seg" id="nvSize"></div>',
      '<p class="hint">Înălțimea fiecărei piese. Grosimea e ~2 cm la ambele.</p></div>'
    ].join("") : "";

    var finishHtml = hasFinish ? [
      '<div class="panel"><p class="step-t"><span class="step-n">', sFin,
      '</span> Alege finisajul</p><div class="seg" id="nvFinish"></div>',
      '<p class="hint">Mat e discret și nu reflectă lumina. Lucios are un luciu fin, ',
      'ca de bomboană.</p></div>'
    ].join("") : "";

    this.root.innerHTML = [
      '<div class="wrap"><div class="cfg">',
        '<div class="board-card">',
          '<div class="board', (this.mode === "perete" ? " wall" : ""), '" id="nvBoard">',
            '<div class="stage" id="nvStage"></div></div>',
          '<div class="bcolors" id="nvBoards"><b>', esc(BOARD_LABEL[this.mode] || "Fundal:"), '</b></div>',
          '<p class="board-note">', esc(c.boardNote), '</p>',
        '</div>',
        '<div>',
          staticIntro ? '<div class="panel nvp-intro" data-nv-intro-slot></div>' : [
            '<div class="panel nvp-intro">',
              '<div class="eyebrow">', esc(c.eyebrow), '</div>',
              '<h1>', esc(c.h1), '</h1>',
              '<p class="subtle">', esc(c.lead), '</p>',
            '</div>'
          ].join(""),
          '<div class="panel"><p class="step-t"><span class="step-n">', sNume,
            '</span> ', esc(this.opts.label), '</p>',
            '<input id="nvName" class="name-input" maxlength="16" autocomplete="off" spellcheck="false">',
            '<p class="hint">', esc(this.opts.hint), '</p>',
          '</div>',
          '<div class="panel"><p class="step-t"><span class="step-n">', sCol,
            '</span> Alege culoarea fiecărei piese</p>',
            '<div class="master" id="nvAll"><span>Aplică tuturor:</span></div>',
            '<div class="letters" id="nvLetters"></div>',
          '</div>',
          sizeHtml, finishHtml,
          '<div class="panel"><p class="step-t"><span class="step-n">', sPrice,
            '</span> Prețul tău</p>',
            '<div class="pricebox">',
              '<div class="prow"><span id="nvRowL">Litere</span><span id="nvValL"></span></div>',
              '<div class="prow" id="nvRowNWrap" style="display:none">',
                '<span id="nvRowN">Cifre</span><span id="nvValN"></span></div>',
              '<div class="ptotal"><span style="font-family:Quicksand;font-weight:700">Total</span>',
              '<b id="nvGrand">—</b></div>',
            '</div>',
            '<button class="btn" id="nvAdd">Adaugă în coș</button>',
            '<p class="delivery">', LIVRARE, '</p>',
            '<div class="reassure">', c.reassure.map(function (r) {
              return "<span>" + esc(r) + "</span>";
            }).join(""), '</div>',
          '</div>',
        '</div>',
      '</div></div>',
      hasAcc ? [
        '<div class="wrap"><div class="acc-sec">',
          '<div class="eyebrow">Mici accesorii magnetice</div>',
          '<h2 style="margin:6px 0 2px;font-size:24px">Accesorii · alegi între 1 și 5, în orice culoare</h2>',
          '<p class="subtle">Forme care completează numele. Pot fi și identice.</p>',
          '<div class="acc-grid" id="nvAccGrid"></div>',
          '<div class="acc-foot"><span class="tag" id="nvAccCount">0 / 5 selectate</span>',
          '<span style="font-size:14px;color:var(--muted)" id="nvAccPrice"></span></div>',
          '<button class="btn" id="nvAddAcc" style="margin-top:14px">Adaugă accesoriile în coș</button>',
        '</div></div>'
      ].join("") : ""
    ].join("");

    if (staticIntro) {
      var slot = this.root.querySelector("[data-nv-intro-slot]");
      if (slot) slot.parentNode.replaceChild(staticIntro, slot);
      staticIntro.classList.add("panel", "nvp-intro");
    }

    if (!document.getElementById("nv-cfg-toast")) {
      var t = el("div"); t.id = "nv-cfg-toast"; document.body.appendChild(t);
    }

    /* fundal */
    var bb = this.root.querySelector("#nvBoards");
    this.boards.forEach(function (b, i) {
      var s = el("div", "bsw" + (i ? "" : " sel"));
      s.style.background = b[0]; s.title = b[1];
      s.onclick = function () {
        self.board = b[0];
        self.root.querySelector("#nvBoard").style.setProperty("--board", b[0]);
        bb.querySelectorAll(".bsw").forEach(function (x) { x.classList.remove("sel"); });
        s.classList.add("sel");
      };
      bb.appendChild(s);
    });
    this.root.querySelector("#nvBoard").style.setProperty("--board", this.board);

    /* aplică tuturor */
    var all = this.root.querySelector("#nvAll");
    cat.colors.forEach(function (col) {
      var s = el("div", "swatch");
      s.style.background = col.css; s.title = col.name;
      s.onclick = function () {
        self.state.forEach(function (g) { if (!g.space) g.color = col.slug; });
        self.refresh();
      };
      all.appendChild(s);
    });

    /* dimensiune + finisaj */
    if (hasSize) this.seg("#nvSize", cat.sizes, this.size, function (v) { self.size = v; self.refresh(); });
    if (hasFinish) this.seg("#nvFinish", cat.finishes, this.finish, function (v) { self.finish = v; self.refresh(); });

    this.root.querySelector("#nvName").addEventListener("input", function (e) {
      self.setName(e.target.value);
    });
    this.root.querySelector("#nvAdd").onclick = function () { self.addToCart(); };

    if (hasAcc) {
      this.root.querySelector("#nvAddAcc").onclick = function () { self.addAccToCart(); };
      this.renderAcc();
    }

    window.addEventListener("resize", function () { self.renderPreview(); });
  };

  Configurator.prototype.seg = function (sel, values, current, onPick) {
    var box = this.root.querySelector(sel);
    if (!box) return;
    box.innerHTML = "";
    values.forEach(function (v) {
      var b = el("button", v === current ? "on" : "", esc(v));
      b.type = "button";
      b.onclick = function () {
        box.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on");
        onPick(v);
      };
      box.appendChild(b);
    });
  };

  Configurator.prototype.setName = function (text) {
    var out = [], li = 0, prev = this.state;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (" ./-\u00b7".indexOf(ch) > -1) { out.push({ space: true }); continue; }
      var slug = glyphSlug(ch);
      if (!slug) continue;
      var old = prev[out.length];
      out.push({
        char: ch.toUpperCase(), slug: slug,
        type: METRICS.glyphs[slug].t,
        color: (old && old.slug === slug && old.color) ? old.color : this.cycle[li % this.cycle.length]
      });
      li++;
    }
    this.state = out;
    var inp = this.root.querySelector("#nvName");
    if (inp.value !== text) inp.value = text;
    this.refresh();
  };

  Configurator.prototype.refresh = function () {
    this.renderPreview();
    this.renderLetters();
    this.calcPrice();
    if (this.root.querySelector("#nvAccGrid")) this.renderAcc();
  };

  Configurator.prototype.renderPreview = function () {
    var stage = this.root.querySelector("#nvStage");
    stage.innerHTML = "";
    var pieces = this.state.filter(function (g) { return !g.space; });
    if (!pieces.length) {
      stage.innerHTML = '<div class="placeholder">Scrie un nume mai sus ✍️</div>';
      return;
    }
    var box = stage.parentElement.getBoundingClientRect();
    var avail = (box.width || 640) * 0.74;
    var availH = Math.max(box.height || 440, 440);
    var cap = 115;
    var self = this;
    function gw(g) {
      var m = METRICS.glyphs[g.slug];
      return m.w * (cap / (m.capBottom - m.capTop));
    }
    function total() {
      var t = 0;
      self.state.forEach(function (g) { t += g.space ? cap * 0.42 : gw(g); });
      return t + cap * 0.07 * Math.max(0, self.state.length - 1);
    }
    var t = total();
    if (t > avail) cap *= avail / t;
    cap = Math.min(cap, availH * 0.40, 125);

    this.state.forEach(function (g) {
      if (g.space) {
        var s = el("span");
        s.style.display = "inline-block";
        s.style.width = (cap * 0.42) + "px"; s.style.height = "1px";
        stage.appendChild(s); return;
      }
      var m = METRICS.glyphs[g.slug];
      var sf = cap / (m.capBottom - m.capTop);
      var w = m.w * sf, h = m.h * sf;
      var wrap = el("span", "glyph");
      wrap.style.width = w + "px"; wrap.style.height = cap + "px";
      wrap.style.marginLeft = wrap.style.marginRight = (cap * 0.035) + "px";
      var img = el("img");
      img.src = imgSrc(g.slug, g.color); img.alt = g.char;
      attachFallback(img);
      img.style.width = w + "px"; img.style.height = h + "px";
      img.style.top = (-(m.capTop * sf)) + "px";
      if (self.mode === "perete") {
        img.style.filter = "drop-shadow(0 5px 7px rgba(60,55,45,.30))";
      }
      wrap.appendChild(img); stage.appendChild(wrap);
    });
  };

  Configurator.prototype.renderLetters = function () {
    var box = this.root.querySelector("#nvLetters"), self = this;
    box.innerHTML = "";
    this.state.forEach(function (g, idx) {
      if (g.space) return;
      var chip = el("div", "lchip");
      var pv = el("div", "pv");
      var im = el("img");
      im.src = imgSrc(g.slug, g.color); im.alt = g.char;
      attachFallback(im);
      var m = METRICS.glyphs[g.slug];
      var sf = 34 / (m.capBottom - m.capTop);
      im.style.height = (m.h * sf) + "px"; im.style.width = (m.w * sf) + "px";
      im.style.bottom = (20 - (m.h - m.capBottom) * sf) + "px";
      im.style.position = "absolute";
      pv.appendChild(im);
      var dots = el("div", "dots");
      self.cat.colors.forEach(function (col) {
        var d = el("div", "dot" + (col.slug === g.color ? " sel" : ""));
        d.style.background = col.css; d.title = col.name;
        d.onclick = function () { self.state[idx].color = col.slug; self.refresh(); };
        dots.appendChild(d);
      });
      chip.appendChild(pv); chip.appendChild(dots);
      box.appendChild(chip);
    });
  };

  /* găsește varianta pentru o piesă */
  Configurator.prototype.variantFor = function (g) {
    var rol = g.type === "num" ? "numbers" : "letters";
    if (!this.cat.products[rol]) rol = "letters";
    return this.cat.find(rol, { color: g.color, size: this.size, finish: this.finish });
  };

  Configurator.prototype.calcPrice = function () {
    var self = this, nL = 0, nN = 0, sumL = 0, sumN = 0, missing = 0, soldOut = 0;
    this.state.forEach(function (g) {
      if (g.space) return;
      var v = self.variantFor(g);
      if (!v) { missing++; return; }
      if (v.available === false) soldOut++;
      if (g.type === "num" && self.cat.products.numbers) { nN++; sumN += v.price; }
      else { nL++; sumL += v.price; }
    });
    var q = function (s) { return self.root.querySelector(s); };
    var rowL = q("#nvRowL").parentElement;
    rowL.style.display = (nL || !nN) ? "flex" : "none";
    q("#nvRowL").textContent = "Litere (" + nL + ")";
    q("#nvValL").textContent = nL ? money(sumL) : "—";
    q("#nvRowNWrap").style.display = nN ? "flex" : "none";
    if (nN) {
      q("#nvRowN").textContent = "Cifre (" + nN + ")";
      q("#nvValN").textContent = money(sumN);
    }
    var totalPieces = nL + nN;
    q("#nvGrand").textContent = totalPieces ? money(sumL + sumN) : "—";
    var btn = q("#nvAdd");
    btn.disabled = !totalPieces || missing > 0 || soldOut > 0;
    btn.textContent = missing > 0 ? "Combinația aleasă nu e disponibilă"
      : soldOut > 0 ? "Stoc epuizat pentru combinația aleasă"
      : "Adaugă în coș";
    this.lastTotal = sumL + sumN;
  };

  Configurator.prototype.addToCart = function () {
    var self = this;
    var pieces = this.state.filter(function (g) { return !g.space; });
    if (!pieces.length) return toast("Scrie întâi un nume");
    var typed = (this.root.querySelector("#nvName").value || "").trim().toUpperCase();
    var nume = typed || pieces.map(function (g) { return g.char; }).join("");
    var setId = "nv-" + nume.toLowerCase() + "-" + (this.lastTotal || 0) + "-" + pieces.length;

    var colorName = function (slug) {
      var c = self.cat.colors.filter(function (x) { return x.slug === slug; })[0];
      return c ? c.name : slug;
    };
    var rezumat = nume + " · " + pieces.map(function (g) {
      return g.char + " " + colorName(g.color).toLowerCase();
    }).join(" · ") + " · " + this.finish.toLowerCase() +
      (this.size ? " · " + this.size : "") + " · " + this.cfg.montaj.toLowerCase();

    var items = [];
    for (var i = 0; i < pieces.length; i++) {
      var g = pieces[i];
      var v = this.variantFor(g);
      if (!v) return toast("Combinația pentru „" + g.char + "” nu e disponibilă");
      if (v.available === false) return toast("„" + g.char + "” e momentan fără stoc în combinația aleasă");
      var props = {
        "Nume": nume,
        "Poziție": (i + 1) + " din " + pieces.length,
        "Piesă": g.char,
        "Culoare": colorName(g.color),
        "Finisaj": this.finish,
        "Montaj": this.cfg.montaj,
        "_set": setId
      };
      if (this.size) props["Dimensiune"] = this.size;
      if (i === 0) props["Rezumat"] = rezumat;
      items.push({ id: v.id, quantity: 1, properties: props });
    }
    this.post(items, "„" + nume + "” adăugat în coș ✓");
  };

  /* ------------------------------------------------------------- accesorii */

  Configurator.prototype.accTotalCount = function () {
    var self = this, t = 0;
    ACCS.forEach(function (a) {
      Object.keys(self.accCounts[a.slug]).forEach(function (k) {
        t += self.accCounts[a.slug][k];
      });
    });
    return t;
  };

  Configurator.prototype.accVariant = function (accSlug, colorSlug) {
    var name = ACCS.filter(function (a) { return a.slug === accSlug; })[0];
    return this.cat.find("acc", {
      acc: name ? name.name : accSlug,
      color: colorSlug,
      finish: this.finish
    });
  };

  Configurator.prototype.renderAcc = function () {
    var grid = this.root.querySelector("#nvAccGrid");
    if (!grid) return;
    var self = this, tot = this.accTotalCount();
    grid.innerHTML = "";
    ACCS.forEach(function (a) {
      var counts = self.accCounts[a.slug];
      var st = Object.keys(counts).reduce(function (s, k) { return s + counts[k]; }, 0);
      var col = self.accColor[a.slug];
      var card = el("div", "acard" + (st > 0 ? " sel" : ""));
      var img = el("img");
      img.src = imgSrc("acc-" + a.slug, col); img.alt = a.name;
      attachFallback(img);
      card.appendChild(img);
      card.appendChild(el("div", "nm", esc(a.name)));
      var dots = el("div", "dots");
      dots.style.cssText = "display:flex;gap:6px;justify-content:center;margin:6px 0 4px;flex-wrap:wrap";
      self.cat.colors.forEach(function (c) {
        var d = el("div", "dot" + (c.slug === col ? " sel" : ""));
        d.style.background = c.css; d.title = c.name;
        d.onclick = function () { self.accColor[a.slug] = c.slug; self.renderAcc(); };
        dots.appendChild(d);
      });
      card.appendChild(dots);
      var qty = el("div", "qty");
      var minus = el("button", "qb", "−"); minus.type = "button"; minus.disabled = st === 0;
      var num = el("span", "qn", String(st));
      var plus = el("button", "qb", "+"); plus.type = "button"; plus.disabled = tot >= 5;
      minus.onclick = function () {
        var c = self.accColor[a.slug];
        if (counts[c]) counts[c]--; else {
          var k = Object.keys(counts)[0]; if (k) counts[k]--;
        }
        Object.keys(counts).forEach(function (k) { if (!counts[k]) delete counts[k]; });
        self.renderAcc();
      };
      var vv = self.accVariant(a.slug, col);
      if (!vv || vv.available === false) {
        plus.disabled = true;
        card.style.opacity = ".55";
        card.appendChild(el("div", "", "fără stoc în combinația aleasă"))
            .style.cssText = "font-size:11px;color:var(--muted);margin-top:6px";
      }
      plus.onclick = function () {
        if (self.accTotalCount() >= 5) return toast("Maxim 5 accesorii");
        var c = self.accColor[a.slug];
        var v = self.accVariant(a.slug, c);
        if (!v || v.available === false) return toast("Combinația aleasă e fără stoc");
        counts[c] = (counts[c] || 0) + 1;
        self.renderAcc();
      };
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
      card.appendChild(qty);
      grid.appendChild(card);
    });

    var n = this.accTotalCount();
    this.root.querySelector("#nvAccCount").textContent = n + " / 5 selectate";
    var line = this.root.querySelector("#nvAccPrice");
    if (n) {
      var sum = 0, ok = true;
      ACCS.forEach(function (a) {
        var counts = self.accCounts[a.slug];
        Object.keys(counts).forEach(function (c) {
          var v = self.accVariant(a.slug, c);
          if (!v) { ok = false; return; }
          sum += v.price * counts[c];
        });
      });
      line.textContent = ok ? (n + (n === 1 ? " accesoriu · " : " accesorii · ") + money(sum))
                            : "Combinația nu e disponibilă";
    } else {
      var v0 = this.accVariant(ACCS[0].slug, this.cat.colors[0].slug);
      line.textContent = v0 ? ("Bucata " + money(v0.price)) : "";
    }
  };

  Configurator.prototype.addAccToCart = function () {
    var self = this;
    if (!this.accTotalCount()) return toast("Alege întâi un accesoriu");
    var items = [];
    var bad = null;
    ACCS.forEach(function (a) {
      var counts = self.accCounts[a.slug];
      Object.keys(counts).forEach(function (c) {
        var q = counts[c]; if (!q) return;
        var v = self.accVariant(a.slug, c);
        if (!v || v.available === false) { bad = a.name; return; }
        var cname = (self.cat.colors.filter(function (x) { return x.slug === c; })[0] || {}).name || c;
        items.push({
          id: v.id, quantity: q,
          properties: {
            "Accesoriu": a.name, "Culoare": cname,
            "Finisaj": self.finish, "Montaj": self.cfg.montaj
          }
        });
      });
    });
    if (bad) return toast("Combinația pentru „" + bad + "” nu e disponibilă");
    this.post(items, "Accesorii adăugate în coș ✓");
  };

  Configurator.prototype.post = function (items, okMsg) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
      toast(okMsg);
      try {
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        window.dispatchEvent(new CustomEvent("cart:updated"));
      } catch (e) {}
    }).catch(function (e) {
      console.error("[nv-cfg]", e);
      toast("Nu am putut adăuga în coș. Încearcă din nou.");
    });
  };

  /* ------------------------------------------------------------- JSON-LD */

  function injectSchema(cat, mode) {
    var p = cat.products.letters;
    if (!p || document.getElementById("nv-cfg-ld")) return;
    var prices = (p.variants || []).map(function (v) { return v.price / 100; });
    if (!prices.length) return;
    var img = (p.images && p.images[0]) ||
              (p.featured_image ? p.featured_image : null);
    var ld = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: p.title,
      description: (COPY[mode].lead || "").slice(0, 300),
      brand: { "@type": "Brand", name: "NESTEVA" },
      url: location.origin + "/products/" + p.handle,
      offers: {
        "@type": "AggregateOffer",
        priceCurrency: "RON",
        lowPrice: Math.min.apply(null, prices).toFixed(2),
        highPrice: Math.max.apply(null, prices).toFixed(2),
        offerCount: prices.length,
        availability: (p.variants || []).some(function (v) { return v.available !== false; })
          ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        seller: { "@type": "Organization", name: "NESTEVA" }
      }
    };
    if (img) ld.image = [String(img).replace(/^\/\//, "https://")];
    var s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "nv-cfg-ld";
    s.textContent = JSON.stringify(ld);
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------------ toast */

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("nv-cfg-toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 1900);
  }

  /* ------------------------------------------------------------------ start */

  function boot() {
    var root = document.getElementById("nv-cfg");
    if (!root || root.dataset.booted) return;
    root.dataset.booted = "1";
    var mode = (root.dataset.mod || "magnet").toLowerCase();
    if (!HANDLES[mode]) mode = "magnet";

    /* păstrăm introducerea scrisă direct în HTML, dacă există */
    var intro = root.querySelector("[data-nv-intro]");
    if (intro) intro.parentNode.removeChild(intro);

    root.innerHTML = '<div class="wrap" style="padding:40px 20px;color:#807c6f">Se încarcă configuratorul…</div>';

    new Catalog().load(HANDLES[mode]).then(function (cat) {
      var cfg = Object.create(Configurator.prototype);
      cfg.staticIntro = intro;
      Configurator.call(cfg, root, mode, cat);
      injectSchema(cat, mode);
      window.NVCFG = { catalog: cat, mode: mode };
    }).catch(function (e) {
      console.error("[nv-cfg]", e);
      root.innerHTML = '<div class="wrap" style="padding:40px 20px;color:#807c6f">' +
        'Configuratorul nu a putut fi încărcat. Reîncarcă pagina, te rugăm.</div>';
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
